module.exports = __webpack_public_path__ + "static/media/digi.5a6a3e63.gif";